import { curry } from 'lodash';
import { Action, ActionCreator, Dispatch } from 'redux';

export const dispatcher = curry(
  (
    dispatch: Dispatch,
    creator: ActionCreator<Action<unknown>>,
    payload: unknown
  ) => dispatch(creator(payload))
);

export interface ActionInterface<ActionType, PayloadType = any> {
  readonly type: ActionType;
  payload?: PayloadType;
}

type apiActions<ActionType, PayloadType = any> = [
  () => ActionInterface<ActionType, void>,
  (payload: PayloadType) => ActionInterface<ActionType, PayloadType>,
  (error: any) => ActionInterface<ActionType>
];

interface ActionTypesMap<ActionType> {
  [key: string]: ActionType;
}

export const generateActions = <ActionType, PayloadType>(
  actionsPrefix: string,
  actionsMap: ActionTypesMap<ActionType>
): apiActions<ActionType, PayloadType> => [
  () => ({ type: actionsMap[`${actionsPrefix}Start`] }),
  (payload: PayloadType) => ({
    payload,
    type: actionsMap[`${actionsPrefix}Success`],
  }),
  (error: any) => ({
    payload: error,
    type: actionsMap[`${actionsPrefix}Error`],
  }),
];
